import Apollo from '@didi/apollo-sdk-javascript'
import defaultConfig from './static/index'
import { Daphne, ApolloEnv, apolloResult, apolloConfig, commonToggle } from 'index'
import { isCountryCode, Omega } from './util'
const CUSTOM_NAME_REG = /^_ns_.*?_name_.*?_key_.*?_phone_.*?$/
const daphne:Daphne = {
  apolloEnv: {},

  commonToggle: {
    countryInfo: ''
  },

  customToggleCache: [],
  async init (opts?: ApolloEnv): Promise<commonToggle> {
    daphne.apolloEnv = opts || {}
    const apolloOpts = {
      ns: 'sailing_common_lda_fe',
      name: ['country_info'],
      key: 'user_key',
      ...daphne.apolloEnv
    }
    const parseCommonConfig = (value: any) => {
      const result:any = {}
      for (const key in value) {
        result[key] = JSON.parse(value[key])
      }
      return result
    }
    if (daphne.commonToggle.countryInfo) {
      console.warn('Daphne:: already init ！ return ')
      return Promise.resolve(daphne._cloneDeep(daphne.commonToggle))
    }
    return new Promise((resolve, reject) => {
      const startTime = new Date().getTime()
      Apollo.getToggle(apolloOpts, (result:commonToggle) => {
        try {
          const endTime = new Date().getTime()
          if (!result.code) {
            daphne.commonToggle.countryInfo = parseCommonConfig(result.data.country_info.params)
            resolve(daphne._cloneDeep(daphne.commonToggle))
            Omega.trackEvent('sailing_daphnesdk_init_success_bt', '获取参数成功', { startTime, time: endTime - startTime })
          } else {
            daphne.commonToggle.countryInfo = parseCommonConfig(defaultConfig.countryInfo)
            resolve(daphne._cloneDeep(daphne.commonToggle))
            console.warn('Daphne:: Apollo getToggle Error! getDefaultConfig')
            Omega.trackEvent('sailing_daphnesdk_init_error_default_logic_bt', '获取参数失败走兜底逻辑', { apolloOpts, result, startTime, time: endTime - startTime })
          }
        } catch (e) {
          reject(e)
          console.error('Daphne:: init Error!')
          console.error(e)
          Omega.trackEvent('sailing_daphnesdk_init_error_bt', 'init 代码逻辑异常', { apolloOpts, error: e })
        }
      })
    })
  },

  async getToggle (opts: apolloConfig): Promise<apolloResult> {
    const apolloOpts = {
      ...daphne.apolloEnv,
      ...opts
    }
    return new Promise((resolve, reject) => {
      const startTime = new Date().getTime()
      Apollo.getToggle(apolloOpts, (result:apolloResult) => {
        try {
          const endTime = new Date().getTime()
          if (!result.code) {
            const customName = daphne._getCustomName(apolloOpts)
            daphne.customToggleCache[customName] = {
              ...result,
              _customName: customName
            }
            resolve(daphne._cloneDeep(daphne.customToggleCache[customName]))
            Omega.trackEvent('sailing_daphnesdk_gettoggle_success_bt', '获取自定义配置成功', { startTime, time: endTime - startTime })
          } else {
            reject(result)
            console.error('Daphne:: Apollo Error! Code: ' + result.code + ', ' + result.message)
            Omega.trackEvent('sailing_daphnesdk_gettoggle_http_error_bt', '获取自定义配置失败', { apolloOpts, result, startTime, time: endTime - startTime })
          }
        } catch (e) {
          reject(e)
          console.error('Daphne:: getToggle Error!')
          console.error(e)
          Omega.trackEvent('sailing_daphnesdk_gettoggle_code_error_bt', 'getToggle 代码逻辑异常', { apolloOpts, error: e })
        }
      })
    })
  },

  getToggleByCache (config: apolloConfig | string): apolloResult {
    let customName
    if (typeof config === 'string') {
      if (CUSTOM_NAME_REG.test(config)) {
        customName = config
      } else {
        throw new Error('Daphne:: config is not _customName')
      }
    } else {
      customName = daphne._getCustomName(config)
    }
    return daphne._cloneDeep(daphne.customToggleCache[customName])
  },

  getCountryCodeList (): any {
    const { list } = daphne.commonToggle.countryInfo
    return list
  },

  getCountryNameList (): any {
    return daphne._getListByKey('countryName')
  },

  getCurrencyList (): any {
    return daphne._getListByKey('currency')
  },

  getLocaleList (): any {
    return daphne._getListByKey('realLocale')
  },

  getLangList (): any {
    return daphne._getListByKey('defaultLang')
  },

  getCallingCodeList (): any {
    return daphne._getListByKey('callingCode')
  },

  getCountryName (country: string): string {
    return daphne._getItemByKeyAndCounty('countryName', country)
  },

  getLang (country: string): string {
    return daphne._getItemByKeyAndCounty('defaultLang', country)
  },

  getCallingCode (country: string): string {
    return daphne._getItemByKeyAndCounty('callingCode', country)
  },

  getCurrency (country: string): string {
    return daphne._getItemByKeyAndCounty('currency', country)[0]
  },

  // 克隆简单实现 防止用户直接修改数据
  _cloneDeep (data) {
    return JSON.parse(JSON.stringify(data))
  },

  _getCustomName ({ ns = '', name = '', key = '', phone = '' }: apolloConfig): string {
    name = typeof name === 'string' ? name : name.join(',')
    return `_ns_${ns}_name_${name}_key_${key}_phone_${phone}`
  },

  _getListByKey (key: string): any {
    const countryInfo = daphne.commonToggle.countryInfo
    const result:any = {}
    for (const k in countryInfo) {
      if (isCountryCode(k)) {
        result[k] = countryInfo[k][key]
      }
    }
    return result
  },

  _getItemByKeyAndCounty (key: string, country: string): string {
    const countryInfo = daphne.commonToggle.countryInfo
    return countryInfo[country][key]
  }
}

export default daphne
